export const QUERY_OPERATORS = [
  'contains',
  'not_contains',
  'true',
  'false',
  'eq',
  'neq',
  'gt',
  'gte',
  'lt',
  'lte',
] as const
